import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Button from '../Button';
import Icon from '../Icon';
import styles from './MoreMenu.module.less';

const MoreMenu = React.forwardRef((props, ref) => {
  const {
    children,
    isOpen = false,
    onClickToggle = function() {},
    onClickItem = function() {},
  } = props;

  return (
    <div className={styles.moreMenu}>
      <Button className={styles.button} color="none" onClick={onClickToggle}>
        More
        <span className={styles.wrapIcon}>
          <Icon
            name="sort-down"
            className={clsx(styles.downIcon, isOpen && styles.flip)}
          />
        </span>
      </Button>
      <div
        ref={ref}
        className={clsx(styles.dropdown, isOpen && styles.open)}
        role="menu"
        onClick={onClickItem}
      >
        <ul>
          {React.Children.map(children, child => (
            <li role="menuitem">{child}</li>
          ))}
        </ul>
      </div>
    </div>
  );
});

MoreMenu.displayName = 'MoreMenu';
MoreMenu.propTypes = {
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  onClickToggle: PropTypes.func,
  onClickItem: PropTypes.func,
};

export default MoreMenu;
